export const requiredColumns = {
  employeeRoster: ["工號", "中文姓名", "組織代碼"],
  departmentCodes: ["部門代碼", "中文名稱", "組織層級"],
  approvalHierarchy: ["Emp No", "Dept Code", "Level 0", "Level 1", "Level 2", "Level 3", "Level 4", "Level 5", "Level 6", "Level 7", "Level 8", "Level 9"],
  performance: ["工號"],
};

export const expectedColumns = {
  employeeRoster: [
    "BUBG",
    "公司代號",
    "組織代碼",
    "工號",
    "中文姓名",
    "英文名",
    "職類名稱",
    "職務名稱",
    "對內職稱或職階",
    "對外職稱",
    "PGrade職等PB",
    "MGrade或JB",
    "性別",
    "年資",
    "年齡",
    "最高學歷",
    "畢業院校",
    "畢業科系",
    "地區",
    "入職日",
    "組織中文名稱",
    "組織英文名稱",
  ],
  departmentCodes: [
    "BG/BU",
    "中文名稱",
    "English Name",
    "部門代碼",
    "組織層級",
    "M Grade",
    "Location",
    "兼",
    "Manager ID",
    "Manager中文名",
    "Manager英文名",
    "秘書ID",
    "秘書中文名",
    "秘書英文名",
  ],
  approvalHierarchy: [
    "Dept Code",
    "Emp No",
    "Name",
    "Login Name",
    "Level 0",
    "Level 1",
    "Level 2",
    "Level 3",
    "Level 4",
    "Level 5",
    "Level 6",
    "Level 7",
    "Level 8",
    "Level 9",
  ],
  performance: ["工號", "中文名", "英文名", "前一期績效", "前二期績效", "前三期績效", "前四期績效"],
};
